// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.teacher-photo {
  display: block;
  flex-shrink: 0;
  object-fit: cover;
  object-position: center top;
  background: #f3f1f7;
}

/*
  Circle size is owned ONLY by the frame — same footprint for photo and
  initials placeholder (overrides must target this class).
*/
.teacher-photo-frame--circle {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-sizing: border-box;
  width: 108px;
  height: 108px;
  min-width: 108px;
  min-height: 108px;
  max-width: 108px;
  max-height: 108px;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.16);
  border: 3px solid #bff1db;
  background: #f3f1f7;
}

.teacher-photo--circle {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  border-radius: 0;
  box-shadow: none;
  border: none;
}

/*
  Schedule avatars: zoom upper/face area, but keep transform-origin at the
  top so hair/headroom is not clipped.
*/
.teacher-photo--circle.teacher-photo--avatar-crop {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  transform: scale(1.75);
  transform-origin: center top;
}

.teacher-photo--portrait {
  width: 38%;
  aspect-ratio: 3 / 4;
  height: auto;
  border-radius: 12px;
  background: #eee;
  object-position: center top;
}

.teacher-photo--placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  gap: 0.3rem;
  text-align: center;
  padding: 0.55rem;
  background:
    radial-gradient(circle at 30% 20%, rgba(192, 241, 220, 0.85), transparent 55%),
    linear-gradient(160deg, #ebe8f2 0%, #d8d4e6 100%);
  color: #403b55;
  overflow: hidden;
  -webkit-user-select: none;
          user-select: none;
  transform: none;
}

.teacher-photo__initials {
  flex-shrink: 0;
  font-size: 1.55rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  line-height: 1;
  color: #1f1b2e;
}

.teacher-photo--portrait .teacher-photo__initials {
  font-size: clamp(1.75rem, 4vw, 2.4rem);
}

.teacher-photo__name {
  max-width: 100%;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1.15;
  color: #5c5670;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  word-break: break-word;
}

.teacher-photo-frame--circle .teacher-photo__name {
  padding: 0 0.2rem;
}

.teacher-photo--portrait .teacher-photo__name {
  font-size: 0.78rem;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  padding: 0 0.35rem;
}

@media (max-width: 700px) {
  .teacher-photo-frame--circle {
    width: 88px;
    height: 88px;
    min-width: 88px;
    min-height: 88px;
    max-width: 88px;
    max-height: 88px;
  }

  .teacher-photo-frame--circle .teacher-photo__initials {
    font-size: 1.25rem;
  }

  .teacher-photo-frame--circle .teacher-photo__name {
    font-size: 0.55rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TeacherPhoto.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;;CAGC;AACD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;;CAGC;AACD;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB;;qDAEmD;EACnD,cAAc;EACd,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".teacher-photo {\n  display: block;\n  flex-shrink: 0;\n  object-fit: cover;\n  object-position: center top;\n  background: #f3f1f7;\n}\n\n/*\n  Circle size is owned ONLY by the frame — same footprint for photo and\n  initials placeholder (overrides must target this class).\n*/\n.teacher-photo-frame--circle {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  box-sizing: border-box;\n  width: 108px;\n  height: 108px;\n  min-width: 108px;\n  min-height: 108px;\n  max-width: 108px;\n  max-height: 108px;\n  aspect-ratio: 1 / 1;\n  border-radius: 50%;\n  overflow: hidden;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.16);\n  border: 3px solid #bff1db;\n  background: #f3f1f7;\n}\n\n.teacher-photo--circle {\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n  max-height: 100%;\n  border-radius: 0;\n  box-shadow: none;\n  border: none;\n}\n\n/*\n  Schedule avatars: zoom upper/face area, but keep transform-origin at the\n  top so hair/headroom is not clipped.\n*/\n.teacher-photo--circle.teacher-photo--avatar-crop {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center top;\n  transform: scale(1.75);\n  transform-origin: center top;\n}\n\n.teacher-photo--portrait {\n  width: 38%;\n  aspect-ratio: 3 / 4;\n  height: auto;\n  border-radius: 12px;\n  background: #eee;\n  object-position: center top;\n}\n\n.teacher-photo--placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  gap: 0.3rem;\n  text-align: center;\n  padding: 0.55rem;\n  background:\n    radial-gradient(circle at 30% 20%, rgba(192, 241, 220, 0.85), transparent 55%),\n    linear-gradient(160deg, #ebe8f2 0%, #d8d4e6 100%);\n  color: #403b55;\n  overflow: hidden;\n  user-select: none;\n  transform: none;\n}\n\n.teacher-photo__initials {\n  flex-shrink: 0;\n  font-size: 1.55rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  line-height: 1;\n  color: #1f1b2e;\n}\n\n.teacher-photo--portrait .teacher-photo__initials {\n  font-size: clamp(1.75rem, 4vw, 2.4rem);\n}\n\n.teacher-photo__name {\n  max-width: 100%;\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  line-height: 1.15;\n  color: #5c5670;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  word-break: break-word;\n}\n\n.teacher-photo-frame--circle .teacher-photo__name {\n  padding: 0 0.2rem;\n}\n\n.teacher-photo--portrait .teacher-photo__name {\n  font-size: 0.78rem;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n  padding: 0 0.35rem;\n}\n\n@media (max-width: 700px) {\n  .teacher-photo-frame--circle {\n    width: 88px;\n    height: 88px;\n    min-width: 88px;\n    min-height: 88px;\n    max-width: 88px;\n    max-height: 88px;\n  }\n\n  .teacher-photo-frame--circle .teacher-photo__initials {\n    font-size: 1.25rem;\n  }\n\n  .teacher-photo-frame--circle .teacher-photo__name {\n    font-size: 0.55rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
